import lodashGet from 'lodash/get';
export class ContactImplMark {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async doGetPersonalMarkList(args = [], field = 'value', options, _account) {
        const needMemberEmail = lodashGet(options, 'needMemberEmail', false);
        const res = await this.ctx.contactDB.getPersonalMarkListByFields(args, field, _account);
        if (!needMemberEmail) {
            return res;
        }
        const groupIds = res.filter(item => item.type === 2).map(item => item.value);
        if (!groupIds || !groupIds.length) {
            return res;
        }
        const contactModelList = await this.ctx.facade.doGetContactByOrgIds(groupIds, _account);
        const getEmaillist = (list) => {
            console.log('[cotact_impl]doGetPersonalMarkList', list);
            const emails = list.flatMap(item => item.contactInfo.filter(item => item.contactItemType === 'EMAIL').map(item => item.contactItemVal));
            return [...new Set(emails)];
        };
        return res.map(item => {
            if (item.type !== 2) {
                return item;
            }
            const emails = getEmaillist(lodashGet(contactModelList, `${item.value}`, []));
            item.emails = emails;
            return item;
        });
    }
    async doGetContactPersonalMarkList() {
        const orgMap = new Map();
        const contactItemMap = new Map();
        const orderIdList = [];
        try {
            const markList = await this.doGetPersonalMarkList();
            const contactIdList = [];
            markList.forEach(item => {
                orderIdList.push(item.value);
                if (item.type === 1) {
                    contactIdList.push(item.value);
                }
                else if (item.type === 2) {
                    orgMap.set(item.value, {
                        id: item.value,
                        originId: item.value,
                        orgName: item.name,
                        orgRank: 0,
                        type: 2001,
                        orgType: 'personalOrg',
                    });
                }
            });
            if (contactIdList.length) {
                const modelList = await this.ctx.facade.doGetContactById(contactIdList);
                modelList.forEach(item => {
                    if (item) {
                        const contactItem = this.ctx.contactUtil.transContactModel2ContactItem(item);
                        contactItemMap.set(item.contact.id, contactItem);
                    }
                });
            }
        }
        catch (e) {
            console.error('[contact_impl] doGetContactPersonalMarkList error', e);
        }
        const list = [];
        orderIdList.forEach(id => {
            const contactItem = contactItemMap.get(id);
            const orgItem = orgMap.get(id);
            const item = contactItem || orgItem;
            if (item) {
                list.push(item);
            }
        });
        return list;
    }
    async doBatchOperatePersonalMark(params, action = 'add') {
        var _a;
        return this.ctx.contactPersonalHelper.doBatchOperatePersonalMark({
            configList: params,
            _account: ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
        }, action);
    }
    doGetPersonalMarklistByEmail(params) {
        const { emails } = params;
        return this.ctx.contactDB.doGetPersonalMarklistByEmail(emails);
    }
    doUpdateMarkUnreadMailCount(idMap) {
        return this.ctx.contactDB.updatePersonalmarkMailUnreadCount(idMap);
    }
    detectCoreEnterpriseHasData(from) {
        return this.ctx.contactDB.detectCoreEnterpriseHasData({ from });
    }
    findContactInfoVal(contactInfoList, type) {
        return this.ctx.contactUtil.findContactInfoVal(contactInfoList, type);
    }
    queryPersonalMemberCount(ids, account) {
        return this.ctx.contactDB.queryPersonalMemberCount(ids, account);
    }
    deleteTrashContactByManual() {
        return this.ctx.contactDB.deleteTrashContactByManual();
    }
}
